<template>
    <div>
        <div elevation="0" color="transparent" flat>
            <div class="row mb-8">
                <div class="col-6 d-flex justify-content-start">
                    <v-card-title>
                        {{ $t("Administration.Categories.CategoryInformation") }} ( {{ catName }} )
                    </v-card-title>
                </div>
                <div class="col-6 d-flex justify-content-end" v-if="tab === 'category-info'">
                    <genericBtnComponent :ClickFun="openDialog" svg="2" :Title="$t('permissions.Save')" />
                </div>
            </div>
        </div>

        <v-card elevation="0">
            <v-tabs v-model="tab" background-color="transparent" class="bg-basil" grow fixed-tabs>
                <v-tab class="text-basil" value="category-info" centered>
                    {{ $t("Administration.Categories.CategoryInformation") }}
                </v-tab>
                <v-tab class="text-basil" value="sub-categories" centered>
                    {{ $t("Administration.Categories.SubCategoriesTitle") }}
                </v-tab>
            </v-tabs>

            <v-window v-model="tab">
                <v-window-item value="category-info" class="px-4">
                    <v-card flat>
                        <v-card-text>
                            <v-form>
                                <v-row>
                                    <v-col cols="8" md="6">
                                        <v-label class="label-left">
                                            {{ $t("Administration.Categories.CategoryName") }}:
                                        </v-label>
                                        <v-text-field v-model="categoryInformationDetails.name" outlined required
                                            hide-details="auto" />
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-label class="label-left">
                                            {{ $t("Administration.Categories.Description") }}:
                                        </v-label>
                                        <v-text-field v-model="categoryInformationDetails.description" outlined
                                            hide-details="auto" />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-label class="label-left">
                                            {{ $t("Administration.Categories.Logo") }}:
                                        </v-label>
                                        <div class="row">
                                            <div class="col justify-content-center" style="max-width: 150px">
                                                <v-img v-if="logoUrl || editCategoryData.logoUrl"
                                                    :src="logoUrl || editCategoryData.logoUrl || defaultImage"
                                                    class="nxmlogo" aspect-ratio="1" width="200"></v-img>
                                                <v-img v-else src="@/assets/upload.png" class="nxmlogo" aspect-ratio="1"
                                                    width="200"></v-img>
                                            </div>
                                            <div class="col justify-content-center" style="width: auto"
                                                v-if="!readonly">
                                                <div class="row" style="padding-left: 12px; padding-bottom: 8px;">
                                                    <div class="upload" @click="chooseLogoFiles()"
                                                        style="cursor: pointer; width: max-content;">
                                                        <svg class="pr-1 pb-1" width="16" height="16"
                                                            viewBox="0 0 24 24" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.53 13.53C11.38 13.68 11.19 13.75 11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L9.75 12.81V17C9.75 17.41 9.41 17.75 9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.54 10.41 8.61 10.36 8.69 10.32C8.71 10.31 8.74 10.3 8.76 10.29C8.82 10.27 8.88 10.26 8.95 10.25C8.98 10.25 9 10.25 9.03 10.25C9.11 10.25 9.19 10.27 9.27 10.3C9.28 10.3 9.28 10.3 9.29 10.3C9.37 10.33 9.45 10.39 9.51 10.45C9.52 10.46 9.53 10.46 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53Z"
                                                                fill="#ffffff" />
                                                            <path
                                                                d="M17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048Z"
                                                                fill="#ffffff" />
                                                        </svg>
                                                        <button type="button" class="load text-center">
                                                            {{ $t("configuration.logo.uploadLogo") }}
                                                        </button>
                                                    </div>
                                                    <v-file-input v-model="editCategoryData.LogoImage"
                                                        accept="image/jpeg, image/png, image/svg+xml" id="fileUpload"
                                                        style="visibility: hidden; display: none;"></v-file-input>
                                                </div>
                                                <div class="row">
                                                    <div class="uploadText">
                                                        {{ $t("configuration.logo.logoMSG") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-window-item>

                <v-window-item value="sub-categories">
                    <SubCategories :subCategoryId="categoryInformationDetails.id" />
                </v-window-item>
            </v-window>
        </v-card>
    </div>
    <dialogDelete :loader="buttonLoader" DialogType="Validation" :title="$t('Administration.Categories.Category')"
        :yes="saveEditedCategory" v-model="dialogValidation" />
</template>

<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import { updateCategory } from "@/api/index";
import dialogDelete from "@/genericComponent/dialogDelete.vue";
import SubCategories from "./SubCategories.vue";
export default {
    components: {
        genericBtnComponent,
        SubCategories,
        dialogDelete,
    },
    props: {
        categoryInformation: {
            type: Object,
            required: true,
        },
        category: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tab: "category-info",
            categoryInformationDetails: this.categoryInformation,
            editCategoryData: {
                id: null,
                name: "",
                description: "",
                status: "",
                LogoImage: null,
            },
            logoUrl: null,
            defaultImage: "@/assets/upload.png",

            buttonLoader: false,
            dialogValidation: false,
            catName: null,
        };
    },
    mounted() {
        this.editCategoryData = {
            id: this.categoryInformation.id,
            name: this.categoryInformation.name,
            description: this.categoryInformation.description,
            logoUrl: this.categoryInformation.logoUrl,
            parentCategoryId: this.categoryInformation.parentCategoryId || null,
        };
        this.catName = this.categoryInformation.name
    },
    methods: {
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        chooseFiles: function () {
            document.getElementById("fileUpload").click();
        },
        openDialog() {
            this.dialogValidation = true;
        },

        onLogoChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.logoUrl = URL.createObjectURL(file); // Prévisualisation
                this.categoryInformationDetails.LogoImage = file; // Stocke le fichier pour l'upload
            }
        },
        chooseLogoFiles() {
            // Créez un élément input de type file pour l'upload du logo
            let input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*"; // Limite l'upload aux images uniquement

            // Ajoutez un écouteur pour capturer la sélection du fichier
            input.onchange = (event) => {
                const file = event.target.files[0];
                if (file) {
                    this.uploadLogo(file); // Appelle une fonction pour uploader et traiter le fichier
                }
            };

            // Déclenche le clic sur l'input invisible
            input.click();
        },
        uploadLogo(file) {
            this.categoryInformationDetails.LogoImage = file;
            const reader = new FileReader();

            // Lorsque le fichier est chargé
            reader.onload = (e) => {
                this.logoUrl = e.target.result; // Met à jour l'URL du logo pour afficher l'image
            };

            // Lecture du fichier comme URL de données
            reader.readAsDataURL(file);
        },
        saveEditedCategory() {
            this.buttonLoader = true;

            const updatedCategory = {
                CategoryId: this.categoryInformationDetails.id,
                name: this.categoryInformationDetails.name,
                description: this.categoryInformationDetails.description,
                parent_category_id: "",
                LogoImage: this.categoryInformationDetails.LogoImage ? this.categoryInformationDetails.LogoImage : "",
            };
            updateCategory(updatedCategory)
                .then(() => {
                    this.$emit("categoryUpdated", updatedCategory);
                    this.ActiveSavedSnackBar();
                    this.catName = this.categoryInformationDetails.name;
                })
                .catch((error) => {
                    console.error("Error updating category:", error);
                    this.ActiveWarningSnackBar();
                })
                .finally(() => {
                    this.buttonLoader = false;
                    this.dialogValidation = false;
                });
        },
    },
};
</script>

<style scoped>
.v-container {
    padding-top: 20px;
}

.v-divider {
    margin-bottom: 20px;
}

.v-label {
    font-size: 14px;
    font-weight: 600;
    color: #001e50;
    margin-bottom: 8px;
}

.required-field {
    color: red;
    font-weight: bold;
    margin-left: 3px;
}

.yes {
    background-color: #114ef7;
    font-weight: 600;
    color: #fff;
}

.Cancel {
    font-weight: 500;
    color: #768da9;
    border: 1px solid #768da9;
}

.bg-basil {
    background-color: #ffffff !important;
}

.text-basil {
    color: #114ef7 !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-family: inter;
}

.label-left {
    display: block;
    /* S'assure que le label prend tout l'espace horizontal */
    text-align: left;
    /* Aligne le texte à gauche */
    margin-bottom: 5px;
    /* Ajoute un léger espacement sous le label si besoin */
}

.uploadText {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: start;
    color: #939eaa;
}

.load {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 34px;
    color: #fff;
}

.upload {
    background-color: #3bbaff;
    width: 144px;
    height: 35px;
    border-radius: 6px;
    text-align: center;
}

.nxmlogo {
    width: 85px;
    height: 85px;
}
</style>
